import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgDialog, IgTypography } from "@intelligems/ig-theme";
import { ExperienceDto } from "@intelligems/ig-types";

import { useEndExperience } from "../../api/experience-actions/end-experience";
import { isDialogOpen, setDialog } from "../../store/slices/global";
import { ExperienceFe } from "../../types/schemas/experiences";
import { endShippingTest } from "../../utils/linkSheet";
import openNewTab from "../../utils/openNewTab";

interface EndTestDialogProps {
  currExperience: ExperienceDto;
}

export const EndShippingTestDialog = ({
  currExperience,
}: EndTestDialogProps) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isDialogOpen("endShippingTest"));
  const endExperience = useEndExperience(false, currExperience!.id!);
  const handleClose = () => {
    dispatch(setDialog({ dialog: "endShippingTest", open: false }));
  };

  const handleExperienceEnd = () => {
    endExperience.mutate({
      body: {
        variationId: undefined,
      },
      pathParams: {
        name: currExperience!.name!,
        experienceId: currExperience!.id!,
        action: "end",
      },
      queryParams: undefined,
    });
    handleClose();
  };

  return (
    <IgDialog
      title={"Wait! Before you end your test"}
      subtitle={
        <IgTypography>
          Please see our article on{" "}
          <IgTypography
            igStyle={"link"}
            onClick={() => {
              openNewTab(endShippingTest, "How to End a Shipping Test");
            }}
          >
            ending your Shipping Test.
          </IgTypography>
        </IgTypography>
      }
      handleClose={handleClose}
      handleYesClick={handleExperienceEnd}
      showDialog={isOpen}
      yesButtonText={"End My Test"}
      dialogHeight={null}
      dialogTitleWidth={"300px"}
      noButtonText={"Cancel"}
      dialogContentWidth={"60px"}
      loading={endExperience.isPending}
      subtitleSx={{ width: "250px", marginBottom: "10px" }}
    />
  );
};
